


























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import ModalEdit from '@/components/ModalEdit.vue';
import { CMProfile } from '@/models/cm-profile.model';
import { CMPRofileApi, _retrieveToken } from '@/services/api.service';
import { validationMixin } from 'vuelidate';
import { required, email, minLength, maxLength } from 'vuelidate/lib/validators';


@Component({
 components: {
   ModalEdit,
 },
 mixins: [validationMixin]
})

export default class ProfileInterests extends Vue {

    public showEditDialog: boolean = false;
    public tagInterests = [];
    public interestsFilled: boolean = false;
    public titleModalEdit: string = '';
    public saving: boolean = false;

    public get profile() {
        return this.$store.getters.profile;
    }

    public mounted() {
        this.interestsFilled = this.profile.interests.length > 0;
    }

    public handleModalClose() {
        this.showEditDialog = false;
    }

    public openModalEdit(event,id?: string) {
        this.tagInterests = this.profile.interests.map((i) => i.refId.toString());
        this.showEditDialog = true;
    }

    public async updateInterests() {
        this.saving = true;
        try {
            this.profile.interests = await CMPRofileApi.updateInterests(this.tagInterests);
            this.interestsFilled = this.profile.interests.length > 0;
            this.$store.commit('updateProfile', this.profile);
            this.showEditDialog = false;
        } catch (e) {
            console.error(e);
        } finally {
            this.saving = false;
        }
    }


}
